/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Location = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        lat: {
            type: 'number',
            isRequired: true,
        },
        long: {
            type: 'number',
            isRequired: true,
        },
        addressName: {
            type: 'string',
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
    },
} as const;
